export const CATEGORY_TYPE = {
  pets: "pets",
  services: "services",
}